import Request from 'gd-request';

class ApiSupport {

    constructor() {}

    getEmailList() {
        return new Request(this,'GET','my-account/emails');
    }

    addEmail(value) {
        return new Request(this,'POST','my-account/emails', {
            email: value
        });
    }

    resendEmailConfirmation(email) {
        return new Request(this,'POST','my-account/emails/'+email);
    }

    setAsPrimary(email) {
        return new Request(this,'PUT','my-account/emails/'+email);
    }

    deleteEmail(email) {
        return new Request(this,'DELETE','my-account/emails/'+email);
    }

    testPrimaryEmail() {
        return new Request(this,'POST','my-account/emails/test-primary');
    }
}


module.exports = ApiSupport;